import appEvents from 'events/app';

export default function clearCurrentRule(dispatch, getState) {
  let state = getState();
  let currentRule = state.app.currentRule;

  if (currentRule) {
    clearTimeout(currentRule.timeoutId);
    dispatch(appEvents.clearCurrentRule());
  }
}
